<button mat-button class="ribbon-button-padding" type="button" (click)="onClick()">
    <mat-icon class="save-icon" [class]="theme.myDialogIconBgColor">arrow_back_ios</mat-icon> 
    
</button>
    